const v = "5.5.7";
const meta = {
	g: "LottieFiles AE 0.1.21",
	a: "",
	k: "",
	d: "",
	tc: ""
};
const fr = 25;
const ip = 0;
const op = 41;
const w = 1200;
const h = 1200;
const nm = "Local Transfer 2";
const ddd = 0;
const assets = [
];
const layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Speed Lines",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					600,
					600,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 0.951,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 6.658,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 7.609,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 9.512,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 10.464,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 11.415,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 18.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 19.024,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 20.927,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 26.634,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 27.585,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 29.488,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30.439,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 31.390625,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0.951,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 9.512,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.024,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 20.927,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 28.536,
											s: [
												0
											]
										},
										{
											t: 29.48828125,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0.951,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 9.512,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.464,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.415,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.024,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 20.927,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 28.536,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 29.488,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.439,
											s: [
												30
											]
										},
										{
											t: 31.390625,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 9.512,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.024,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.976,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 28.536,
											s: [
												-17
											]
										},
										{
											t: 29.48828125,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								24,
								-532
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 0.951,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 1.902,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 11.415,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 12.366,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 19.024,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 20.927,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 21.878,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 31.391,
									s: [
										100
									]
								},
								{
									t: 32.341796875,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_01",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 0.951,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 6.658,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 7.609,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 9.512,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 10.464,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 11.415,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 18.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 19.024,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 20.927,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 26.634,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 27.585,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 29.488,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30.439,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 31.390625,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0.951,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 9.512,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.024,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 20.927,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 28.536,
											s: [
												0
											]
										},
										{
											t: 29.48828125,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0.951,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 9.512,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.464,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.415,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.024,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 20.927,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 28.536,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 29.488,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.439,
											s: [
												30
											]
										},
										{
											t: 31.390625,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 9.512,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.024,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.976,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 28.536,
											s: [
												-17
											]
										},
										{
											t: 29.48828125,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								502,
								19
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 3.609,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 4.561,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 11,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 11.951,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 20.731,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 21.683,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 23.585,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 24.536,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 31,
									s: [
										100
									]
								},
								{
									t: 31.951171875,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_05",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 4.561,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 10.268,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 11.219,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 13.121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 14.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 15.024,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 21.683,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 22.634,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 24.536,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30.243,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 31.194,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 33.098,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 34.049,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 35,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												0
											]
										},
										{
											t: 33.09765625,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 14.073,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 15.024,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 33.098,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 34.049,
											s: [
												30
											]
										},
										{
											t: 35,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 3.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 23.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												-17
											]
										},
										{
											t: 33.09765625,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								371,
								402
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 4.561,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 5.512,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.024,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.976,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 21.683,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 22.634,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 24.536,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 25.487,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										100
									]
								},
								{
									t: 35.951171875,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_06",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 4.561,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 10.268,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 11.219,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 13.121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 14.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 15.024,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 21.683,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 22.634,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 24.536,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30.243,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 31.194,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 33.098,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 34.049,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 35,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												0
											]
										},
										{
											t: 33.09765625,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 14.073,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 15.024,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 33.098,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 34.049,
											s: [
												30
											]
										},
										{
											t: 35,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 3.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 23.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												-17
											]
										},
										{
											t: 33.09765625,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								213,
								105
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 4.561,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 5.512,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.024,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.976,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 21.683,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 22.634,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 24.536,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 25.487,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										100
									]
								},
								{
									t: 35.951171875,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_04",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 4.561,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 10.268,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 11.219,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 13.121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 14.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 15.024,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 21.683,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 22.634,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 24.536,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30.243,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 31.194,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 33.098,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 34.049,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 35,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												0
											]
										},
										{
											t: 33.09765625,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 14.073,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 15.024,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 33.098,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 34.049,
											s: [
												30
											]
										},
										{
											t: 35,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 3.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 23.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												-17
											]
										},
										{
											t: 33.09765625,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-252,
								-59
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 4.561,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 5.512,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.024,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.976,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 21.683,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 22.634,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 24.536,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 25.487,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										100
									]
								},
								{
									t: 35.951171875,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_03",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 4.561,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 10.268,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 11.219,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 13.121,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 14.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 15.024,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 21.683,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 22.634,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 24.536,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30.243,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 31.194,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 33.098,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 34.049,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 35,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												0
											]
										},
										{
											t: 33.09765625,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 4.561,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 14.073,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 15.024,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.536,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 33.098,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 34.049,
											s: [
												30
											]
										},
										{
											t: 35,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 3.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.268,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 11.219,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 12.17,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.121,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 21.683,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 22.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 23.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 30.243,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 31.194,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 32.146,
											s: [
												-17
											]
										},
										{
											t: 33.09765625,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-403,
								-408
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 4.561,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 5.512,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.024,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 15.976,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 21.683,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 22.634,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 24.536,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 25.487,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										100
									]
								},
								{
									t: 35.951171875,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_02",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 7.609,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 13.316,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 14.268,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 16.17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 17.122,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 18.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 24.731,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 25.683,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 27.585,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 33.292,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 34.243,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 36,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 37.098,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 38.048828125,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.316,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 14.268,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 15.219,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 16.17,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.731,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 25.683,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 33.292,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 34.243,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 35.194,
											s: [
												0
											]
										},
										{
											t: 36.146484375,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.316,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 14.268,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 15.219,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 16.17,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 17.122,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.731,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 25.683,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 33.292,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 34.243,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 35.194,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 36.146,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 37.098,
											s: [
												30
											]
										},
										{
											t: 38.048828125,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 13.316,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 14.268,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 15.219,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 16.17,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 24.731,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 25.683,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 33.292,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 34.243,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 35.194,
											s: [
												-17
											]
										},
										{
											t: 36.146484375,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-290,
								455
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 7.609,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 8.561,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 18.073,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 19.024,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 24.731,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 25.683,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 27.585,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 28.536,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 38.049,
									s: [
										100
									]
								},
								{
									t: 39,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_07",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 7,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 5.707,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 6.658,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 8.561,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 9.513,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 10.464,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 17.122,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 18.073,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 19.976,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													117.5,
													250.5
												],
												[
													114.5,
													248
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 25.683,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													249.818,
													318
												],
												[
													128.5,
													255.5
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 26.634,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													271.921,
													329.733
												],
												[
													141.2,
													262.2
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 28.537,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.127,
													353.2
												],
												[
													187.6,
													286.1
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 29.488,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													316.564,
													354.1
												],
												[
													195.3,
													289.8
												]
											],
											c: false
										}
									]
								},
								{
									t: 30.439453125,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													328.5,
													361.5
												],
												[
													227,
													306.5
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.529411764706,
								0.737254901961,
								0.964705882353,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 13,
							ix: 5
						},
						lc: 2,
						lj: 3,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 5.707,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 17.122,
											s: [
												6
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.976,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 25.683,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												0
											]
										},
										{
											t: 28.537109375,
											s: [
												6
											]
										}
									],
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 0,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 5.707,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 9.513,
											s: [
												30
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 10.464,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 17.122,
											s: [
												38
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.976,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 25.683,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												10
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 28.537,
											s: [
												24
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 29.488,
											s: [
												30
											]
										},
										{
											t: 30.439453125,
											s: [
												38
											]
										}
									],
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 1,
									k: [
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: -0.951,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 5.707,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 6.658,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 7.609,
											s: [
												-17
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 8.561,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 17.122,
											s: [
												-21
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 18.073,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 19.024,
											s: [
												0
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 25.683,
											s: [
												-22
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 26.634,
											s: [
												-19.5
											]
										},
										{
											i: {
												x: [
													0.833
												],
												y: [
													0.833
												]
											},
											o: {
												x: [
													0.167
												],
												y: [
													0.167
												]
											},
											t: 27.585,
											s: [
												-17
											]
										},
										{
											t: 28.537109375,
											s: [
												-21
											]
										}
									],
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 0,
							k: 100,
							ix: 2
						},
						o: {
							a: 0,
							k: -6,
							ix: 3
						},
						m: 1,
						ix: 3,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								393,
								-467
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								162,
								274
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 110,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 0,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 0.951,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 10.464,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 11.415,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 17.122,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 18.073,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 19.976,
									s: [
										0
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 20.927,
									s: [
										100
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 30.439,
									s: [
										100
									]
								},
								{
									t: 31.390625,
									s: [
										0
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Lines_08",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 8,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 80,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Rocket",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: -43,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					700,
					455,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					763.485,
					487,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														-63.233,
														55.138
													],
													[
														0,
														0
													]
												],
												v: [
													[
														480.102,
														533.294
													],
													[
														235.177,
														746.975
													]
												],
												c: false
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "st",
										c: {
											a: 0,
											k: [
												0.843109130859,
												0.964691162109,
												0.799987792969,
												1
											],
											ix: 3
										},
										o: {
											a: 0,
											k: 100,
											ix: 4
										},
										w: {
											a: 0,
											k: 10,
											ix: 5
										},
										lc: 2,
										lj: 1,
										ml: 4,
										bm: 0,
										d: [
											{
												n: "d",
												nm: "dash",
												v: {
													a: 0,
													k: 55,
													ix: 1
												}
											},
											{
												n: "g",
												nm: "gap",
												v: {
													a: 0,
													k: 120,
													ix: 2
												}
											},
											{
												n: "o",
												nm: "offset",
												v: {
													a: 1,
													k: [
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 0,
															s: [
																-30
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 13.5,
															s: [
																-554
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 15,
															s: [
																-30
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 28.5,
															s: [
																-554
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 30,
															s: [
																-30
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 43.5,
															s: [
																-554
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 45,
															s: [
																-30
															]
														},
														{
															t: 60,
															s: [
																-554
															]
														}
													],
													ix: 7
												}
											}
										],
										nm: "Stroke 1",
										mn: "ADBE Vector Graphic - Stroke",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Top",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														57.629,
														-48.206
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														512.279,
														590.124
													],
													[
														343.515,
														728.323
													]
												],
												c: false
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "st",
										c: {
											a: 0,
											k: [
												0.843109130859,
												0.964691162109,
												0.799987792969,
												1
											],
											ix: 3
										},
										o: {
											a: 0,
											k: 100,
											ix: 4
										},
										w: {
											a: 0,
											k: 15,
											ix: 5
										},
										lc: 2,
										lj: 1,
										ml: 4,
										bm: 0,
										d: [
											{
												n: "d",
												nm: "dash",
												v: {
													a: 0,
													k: 39,
													ix: 1
												}
											},
											{
												n: "g",
												nm: "gap",
												v: {
													a: 0,
													k: 68,
													ix: 2
												}
											},
											{
												n: "o",
												nm: "offset",
												v: {
													a: 1,
													k: [
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 0,
															s: [
																-2194
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 13,
															s: [
																-2514
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 14,
															s: [
																-2194
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 27,
															s: [
																-2514
															]
														},
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 28,
															s: [
																-2194
															]
														},
														{
															t: 41,
															s: [
																-2514
															]
														}
													],
													ix: 7
												}
											}
										],
										nm: "Stroke 1",
										mn: "ADBE Vector Graphic - Stroke",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Bttm",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 2,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										411.957,
										627.035
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										411.957,
										627.035
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Inner Dashes",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														40.102,
														-74.337
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														6.702,
														-68.948
													],
													[
														0,
														0
													],
													[
														14.364,
														16.518
													]
												],
												v: [
													[
														-10.978,
														80.223
													],
													[
														-25.965,
														-41.784
													],
													[
														18.24,
														-80.223
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.043137256056,
												0.337254911661,
												0.658823549747,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												887.077,
												278.203
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 4",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														-14.364,
														-16.518
													],
													[
														0,
														0
													],
													[
														69.196,
														2.934
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														79.171,
														-29.394
													]
												],
												v: [
													[
														81.463,
														-12.274
													],
													[
														37.259,
														26.165
													],
													[
														-81.463,
														-5.621
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.015686275437,
												0.450980395079,
												0.917647063732,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												823.853,
												210.255
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 5",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 2,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														25.219,
														-21.93
													],
													[
														21.93,
														25.219
													],
													[
														-25.219,
														21.93
													],
													[
														-21.93,
														-25.219
													]
												],
												o: [
													[
														-25.219,
														21.93
													],
													[
														-21.93,
														-25.219
													],
													[
														25.219,
														-21.93
													],
													[
														21.93,
														25.219
													]
												],
												v: [
													[
														39.708,
														45.663
													],
													[
														-45.663,
														39.708
													],
													[
														-39.708,
														-45.663
													],
													[
														45.663,
														-39.708
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "st",
										c: {
											a: 0,
											k: [
												0.015686275437,
												0.450980395079,
												0.917647063732,
												1
											],
											ix: 3
										},
										o: {
											a: 0,
											k: 100,
											ix: 4
										},
										w: {
											a: 0,
											k: 25,
											ix: 5
										},
										lc: 1,
										lj: 1,
										ml: 10,
										bm: 0,
										nm: "Stroke 1",
										mn: "ADBE Vector Graphic - Stroke",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.811764717102,
												0.89411765337,
												0.984313726425,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												733.788,
												347.138
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 6",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 3,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														120.263,
														-37.748
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														6.702,
														-68.948
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-38.09,
														70.586
													]
												],
												v: [
													[
														-85.996,
														152.6
													],
													[
														-144.764,
														85.018
													],
													[
														128.492,
														-152.6
													],
													[
														143.478,
														-30.594
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.341176480055,
												0.635294139385,
												0.949019610882,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												732.608,
												389.037
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 7",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 4,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-75.197,
														27.913
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														54.087,
														-113.864
													],
													[
														69.196,
														2.934
													]
												],
												v: [
													[
														166.015,
														-102.916
													],
													[
														-107.241,
														134.702
													],
													[
														-166.015,
														67.113
													],
													[
														47.293,
														-134.702
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.529411792755,
												0.737254917622,
												0.964705884457,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												695.085,
												339.352
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 8",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 5,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														-28.002,
														-32.201
													],
													[
														244.607,
														-78.003
													],
													[
														12.955,
														14.898
													]
												],
												o: [
													[
														28.002,
														32.201
													],
													[
														-16.675,
														-19.176
													],
													[
														111.039,
														-233.755
													]
												],
												v: [
													[
														184.311,
														-165.297
													],
													[
														-73.655,
														179.186
													],
													[
														-191.923,
														43.181
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.529411792755,
												0.737254917622,
												0.964705884457,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												720.993,
												363.288
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 9",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 6,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														132.26,
														152.096
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-132.26,
														-152.096
													]
												],
												v: [
													[
														-149.678,
														-46.272
													],
													[
														22.184,
														151.366
													],
													[
														106.953,
														-94.311
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.043137256056,
												0.337254911661,
												0.658823549747,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												675.849,
												398.847
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 10",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 7,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														155.73,
														179.086
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-155.73,
														-179.086
													]
												],
												v: [
													[
														-154.21,
														-72.478
													],
													[
														48.15,
														160.233
													],
													[
														95.438,
														-83.367
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.015686275437,
												0.450980395079,
												0.917647063732,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												665.516,
												406.883
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 11",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 8,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														4.248,
														4.916
													],
													[
														0,
														0
													],
													[
														-2.275,
														3.875
													],
													[
														108.887,
														-44.959
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-2.949,
														-3.391
													],
													[
														59.655,
														-101.59
													],
													[
														-4.153,
														1.715
													]
												],
												v: [
													[
														15.802,
														66.248
													],
													[
														-66.642,
														-28.561
													],
													[
														-67.761,
														-40.726
													],
													[
														30.153,
														71.875
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.015686275437,
												0.450980395079,
												0.917647063732,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												595.521,
												468.15
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Group 12",
								np: 2,
								cix: 2,
								bm: 0,
								ix: 9,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										712.174,
										375.602
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										712.174,
										375.602
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Rocket 1",
						np: 9,
						cix: 2,
						bm: 0,
						ix: 2,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										d: 1,
										ty: "el",
										s: {
											a: 0,
											k: [
												127,
												127
											],
											ix: 2
										},
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 3
										},
										nm: "Ball",
										mn: "ADBE Vector Shape - Ellipse",
										hd: false
									},
									{
										ind: 1,
										ty: "sh",
										ix: 2,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0.373,
														-8.588
													],
													[
														-0.036,
														7.208
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-0.373,
														8.588
													],
													[
														0.036,
														-7.208
													],
													[
														0,
														0
													]
												],
												v: [
													[
														13.316,
														7.982
													],
													[
														3.316,
														548.001
													],
													[
														-3.316,
														548.036
													],
													[
														-13.316,
														7.982
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Tail",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.843137254902,
												0.964705882353,
												0.8,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												611.238,
												453.417
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												-62
											],
											ix: 1
										},
										s: {
											a: 1,
											k: [
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 0,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 2.5,
													s: [
														119,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 5,
													s: [
														100,
														105
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 8,
													s: [
														124,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 10,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 12.5,
													s: [
														119,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 15,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 17.5,
													s: [
														119,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 20,
													s: [
														100,
														93
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 22.5,
													s: [
														119,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 25,
													s: [
														96,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 27.5,
													s: [
														119,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 30,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 32.5,
													s: [
														119,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 35,
													s: [
														100,
														108
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 37.5,
													s: [
														119,
														100
													]
												},
												{
													t: 40,
													s: [
														100,
														100
													]
												}
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 49,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Inner",
								np: 4,
								cix: 2,
								bm: 0,
								ix: 1,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										d: 1,
										ty: "el",
										s: {
											a: 0,
											k: [
												187,
												187
											],
											ix: 2
										},
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 3
										},
										nm: "Ball 2",
										mn: "ADBE Vector Shape - Ellipse",
										hd: false
									},
									{
										ind: 1,
										ty: "sh",
										ix: 2,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0.616,
														-8.588
													],
													[
														2.238,
														53.297
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-1.488,
														47.332
													],
													[
														-1.141,
														-27.184
													],
													[
														0,
														0
													]
												],
												v: [
													[
														41.42,
														7.982
													],
													[
														24.908,
														548.001
													],
													[
														-21.318,
														548.036
													],
													[
														-35.58,
														7.982
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Tail 2",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.219607843137,
												0.823529411765,
												0,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												633.88,
												433.735
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												-92
											],
											ix: 1
										},
										s: {
											a: 1,
											k: [
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 0,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 2.5,
													s: [
														109,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 5,
													s: [
														100,
														105
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 8,
													s: [
														114,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 10,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 12.5,
													s: [
														109,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 15,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 17.5,
													s: [
														109,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 20,
													s: [
														100,
														94
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 22.5,
													s: [
														109,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 25,
													s: [
														96,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 27.5,
													s: [
														109,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 30,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 32.5,
													s: [
														109,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 35,
													s: [
														100,
														107
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 37.5,
													s: [
														109,
														100
													]
												},
												{
													t: 40,
													s: [
														100,
														100
													]
												}
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 49,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Mid",
								np: 4,
								cix: 2,
								bm: 0,
								ix: 2,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														33.682,
														-29.28
													]
												],
												o: [
													[
														-27.253,
														23.691
													],
													[
														0,
														0
													]
												],
												v: [
													[
														221.957,
														793.695
													],
													[
														63.468,
														931.467
													]
												],
												c: false
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "st",
										c: {
											a: 0,
											k: [
												0.219604492188,
												0.823516845703,
												0,
												1
											],
											ix: 3
										},
										o: {
											a: 0,
											k: 100,
											ix: 4
										},
										w: {
											a: 0,
											k: 47,
											ix: 5
										},
										lc: 2,
										lj: 1,
										ml: 4,
										bm: 0,
										d: [
											{
												n: "d",
												nm: "dash",
												v: {
													a: 0,
													k: 164,
													ix: 1
												}
											},
											{
												n: "g",
												nm: "gap",
												v: {
													a: 0,
													k: 44,
													ix: 2
												}
											},
											{
												n: "d",
												nm: "dash2",
												v: {
													a: 0,
													k: 0,
													ix: 3
												}
											},
											{
												n: "o",
												nm: "offset",
												v: {
													a: 1,
													k: [
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 0,
															s: [
																0
															]
														},
														{
															t: 41,
															s: [
																-1e3
															]
														}
													],
													ix: 7
												}
											}
										],
										nm: "Stroke 1",
										mn: "ADBE Vector Graphic - Stroke",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "End 2",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 3,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										d: 1,
										ty: "el",
										s: {
											a: 0,
											k: [
												244.2,
												244.2
											],
											ix: 2
										},
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 3
										},
										nm: "Ellipse Path 1",
										mn: "ADBE Vector Shape - Ellipse",
										hd: false
									},
									{
										ind: 1,
										ty: "sh",
										ix: 2,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0.936,
														-8.917
													],
													[
														3.329,
														57.364
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														-2.41,
														57.4
													],
													[
														-1.637,
														-28.211
													],
													[
														0,
														0
													]
												],
												v: [
													[
														61.92,
														7.982
													],
													[
														36.83,
														561.432
													],
													[
														-33.409,
														561.469
													],
													[
														-55.08,
														7.982
													]
												],
												c: true
											},
											ix: 2
										},
										nm: "Tail 3",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.137254901961,
												0.521568627451,
												0,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												656.422,
												415.464
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												1,
												-121
											],
											ix: 1
										},
										s: {
											a: 1,
											k: [
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 0,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 2.5,
													s: [
														108,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 5,
													s: [
														100,
														106
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 8,
													s: [
														113,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 10,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 12.5,
													s: [
														108,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 15,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 17.5,
													s: [
														108,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 20,
													s: [
														100,
														94
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 22.5,
													s: [
														108,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 25,
													s: [
														95,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 27.5,
													s: [
														108,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 30,
													s: [
														100,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 32.5,
													s: [
														108,
														100
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 35,
													s: [
														100,
														104.9
													]
												},
												{
													i: {
														x: [
															0.833,
															0.833
														],
														y: [
															0.833,
															0.833
														]
													},
													o: {
														x: [
															0.167,
															0.167
														],
														y: [
															0.167,
															0.167
														]
													},
													t: 37.5,
													s: [
														108,
														100
													]
												},
												{
													t: 40,
													s: [
														100,
														100
													]
												}
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 49,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "Outer",
								np: 4,
								cix: 2,
								bm: 0,
								ix: 4,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "gr",
								it: [
									{
										ind: 0,
										ty: "sh",
										ix: 1,
										ks: {
											a: 0,
											k: {
												i: [
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												o: [
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														253.048,
														764.68
													],
													[
														22.862,
														964.778
													]
												],
												c: false
											},
											ix: 2
										},
										nm: "Path 1",
										mn: "ADBE Vector Shape - Group",
										hd: false
									},
									{
										ty: "st",
										c: {
											a: 0,
											k: [
												0.137237548828,
												0.521545410156,
												0,
												1
											],
											ix: 3
										},
										o: {
											a: 0,
											k: 100,
											ix: 4
										},
										w: {
											a: 0,
											k: 75,
											ix: 5
										},
										lc: 2,
										lj: 1,
										ml: 4,
										bm: 0,
										d: [
											{
												n: "d",
												nm: "dash",
												v: {
													a: 0,
													k: 149,
													ix: 1
												}
											},
											{
												n: "g",
												nm: "gap",
												v: {
													a: 0,
													k: 96,
													ix: 2
												}
											},
											{
												n: "o",
												nm: "offset",
												v: {
													a: 1,
													k: [
														{
															i: {
																x: [
																	0.833
																],
																y: [
																	0.833
																]
															},
															o: {
																x: [
																	0.167
																],
																y: [
																	0.167
																]
															},
															t: 0,
															s: [
																-304.1
															]
														},
														{
															t: 40,
															s: [
																-1282.4
															]
														}
													],
													ix: 7
												}
											}
										],
										nm: "Stroke 1",
										mn: "ADBE Vector Graphic - Stroke",
										hd: false
									},
									{
										ty: "fl",
										c: {
											a: 0,
											k: [
												0.137254901961,
												0.521568627451,
												0,
												1
											],
											ix: 4
										},
										o: {
											a: 0,
											k: 100,
											ix: 5
										},
										r: 1,
										bm: 0,
										nm: "Fill 1",
										mn: "ADBE Vector Graphic - Fill",
										hd: false
									},
									{
										ty: "tr",
										p: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 2
										},
										a: {
											a: 0,
											k: [
												0,
												0
											],
											ix: 1
										},
										s: {
											a: 0,
											k: [
												100,
												100
											],
											ix: 3
										},
										r: {
											a: 0,
											k: 0,
											ix: 6
										},
										o: {
											a: 0,
											k: 100,
											ix: 7
										},
										sk: {
											a: 0,
											k: 0,
											ix: 4
										},
										sa: {
											a: 0,
											k: 0,
											ix: 5
										},
										nm: "Transform"
									}
								],
								nm: "End",
								np: 3,
								cix: 2,
								bm: 0,
								ix: 5,
								mn: "ADBE Vector Group",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										564.446,
										494.092
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										564.446,
										494.092
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										87,
										87
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "GO! 1",
						np: 5,
						cix: 2,
						bm: 0,
						ix: 3,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.494,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: -10,
									s: [
										572.589,
										487.282
									],
									to: [
										10.3,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.479,
										y: 0.999
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 10,
									s: [
										634.389,
										487.282
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.508,
										y: 0.001
									},
									t: 30,
									s: [
										572.589,
										487.282
									],
									to: [
										0,
										0
									],
									ti: [
										0,
										0
									]
								},
								{
									i: {
										x: 0.54,
										y: 0.999
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 46,
									s: [
										634.389,
										487.282
									],
									to: [
										0,
										0
									],
									ti: [
										10.3,
										0
									]
								},
								{
									t: 69,
									s: [
										572.589,
										487.282
									]
								}
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								572.589,
								487.282
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 41,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Zoom 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 80,
		st: 0,
		bm: 0
	}
];
const markers = [
];
const ani51 = {
	v: v,
	meta: meta,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

export { assets, ddd, ani51 as default, fr, h, ip, layers, markers, meta, nm, op, v, w };
